import { AppError } from './AppError';

/**
 * Raised when an authenticated user is missing a required permission (the
 * `can()` check from @dma/auth returned false). Distinct from
 * AuthenticationFailedError (features/admin) which is about *identity* —
 * this is about *access*: the user is who they say they are, but not
 * allowed to do this specific thing.
 */
export class AuthorizationError extends AppError {
  constructor(message = 'شما اجازه‌ی انجام این عملیات را ندارید.', options?: { cause?: unknown }) {
    super('FORBIDDEN', message, options);
    this.name = 'AuthorizationError';
    Object.setPrototypeOf(this, AuthorizationError.prototype);
  }
}
